/**
 * Query-level Algolia settings, for previewing a settings change before it is
 * applied to the index.
 *
 * removeWordsIfNoResults, ignorePlurals and queryLanguages are accepted as
 * request parameters as well as index settings, so a deploy preview can search
 * as though the settings were already live. That is how they were measured, and
 * it means the priority 1 fix can be demonstrated against the real index
 * without copying it or writing anything.
 *
 * Empty in production, where the settings are applied properly by
 * scripts/applyAlgoliaSettings.js. Delete this once they are applied — it is a
 * preview mechanism with no reason to outlive the change it previews.
 *
 * Set NEXT_PUBLIC_ALGOLIA_QUERY_DEFAULTS in the Netlify deploy-preview context:
 *   {"removeWordsIfNoResults":"allOptional","ignorePlurals":true,"queryLanguages":["en","ja"]}
 */
export const getAlgoliaQueryDefaults = (): Record<string, unknown> => {
  const raw = process.env.NEXT_PUBLIC_ALGOLIA_QUERY_DEFAULTS;
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    // A malformed value must not take search down; a preview silently behaving
    // like production is the acceptable failure here.
    console.warn('[algolia] NEXT_PUBLIC_ALGOLIA_QUERY_DEFAULTS is not valid JSON, ignoring');
    return {};
  }
};
